import { EVENT_LOG } from './copy';
import type { OfflineModeEvent, OfflineModeEventChain } from 'redux-stores/offlineMode';

export const ACTIVATION_TYPE = 'activation';

export type CurrentActivationLog = {
  events: OfflineModeEvent[];
  reachesActivation: boolean;
};

export function currentActivationLog(events: OfflineModeEvent[]): CurrentActivationLog {
  const activationIndex = events.findIndex((event) => event.eventType === ACTIVATION_TYPE);
  const reachesActivation = activationIndex >= 0;
  const scoped = reachesActivation ? events.slice(0, activationIndex + 1) : events;

  return { events: [...scoped].reverse(), reachesActivation };
}

export function hasBroadcastSince(events: OfflineModeEvent[], activeSince: number): boolean {
  if (!activeSince) return false;
  return events.some((event) => event.eventType === 'broadcast' && event.occurredAt >= activeSince);
}

const findingLine = (type: string): string =>
  Object.prototype.hasOwnProperty.call(EVENT_LOG.integrity.findings, type)
    ? EVENT_LOG.integrity.findings[type]
    : EVENT_LOG.integrity.unrecognised;

export function integrityFindings(chains: OfflineModeEventChain[]): string[] | null {
  const broken = chains.filter((chain) => !chain.intact);
  if (!broken.length) return null;
  return Array.from(
    new Set(broken.flatMap((chain) => chain.findings).map((finding) => findingLine(finding.type)))
  );
}
